export default "<ion-label>{{ number }}</ion-label>\n";